/// <reference path="onlinePresenceSettings.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.OnlinePresenceSettings {

    class OnlinePresenceSettingsController extends Meevo.Components.CommonClasses.CommonControllerBase {
        // statically inject constructor resources
        static $inject = [
            'meevo.AppSettings',
            'meevo.components.common.BusinessInfoDataService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.IdentityService',
            'meevo.components.logging.LoggingService',
            'meevo.components.common.SecurityService',
            'meevo.components.tracking.TrackingService',
            'meevo.components.busy.BusyService',
            '$rootScope',
            '$state',
            '$scope',
            'meevo.ContextParams',
            'meevo.components.short-cuts.ShortCutsService',
            '$translate',
            '$mdDialog',
            '$q'
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.CommonClasses.ICommonDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $rootScope: angular.IRootScopeService,
            protected $state: any,
            protected $scope: angular.IScope,
            protected contextParams: any,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected $translate: angular.translate.ITranslateService,
            protected $mdDialog: ng.material.IDialogService,
            protected $q: angular.IQService) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.createContext();
        }

        createContext(): void {
            this.busyService.start();

            this.securityService.checkSection(this.meevoSecurityKeys.MARKETING_ONLINEPRESENCESETTINGS + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE).then(() => {
                this.busyService.stop();
                this.context = new OnlinePresenceSettingsContext(this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, this.securityService, this.trackingService, this.busyService, this.$scope, this.$translate, this.$mdDialog, this.$q, this.$rootScope);
                super.createContext();
            });
        }

       
    }

    angular.module("meevo.plugins.onlinePresenceSettings")
        .controller("meevo.plugins.onlinePresenceSettings.OnlinePresenceSettingsController", OnlinePresenceSettingsController);
}